import { Component, inject } from '@angular/core';
import { EnvironmentService } from '@pepconnect/services/environment.service';
import { BaseV2SmartComponent } from '@pepconnect/shared/base/base-smart-component-v2';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent extends BaseV2SmartComponent {
  private readonly environmentService = inject(EnvironmentService);
  readonly showLogin: boolean = !this.environmentService.isCMS; // do not show login page for CMS users
}
